import React from "react";

import { LoadState } from "@/lib/scan-ui/screen";
import { HonestSignCard } from "@/pages/settings/cards/HonestSignCard";
import { ScanMethodCard } from "@/pages/settings/cards/ScanMethodCard";
import { TechRefsCard } from "@/pages/settings/cards/TechRefsCard";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { useSystemSettingsQuery } from "@/pages/settings/useSystemSettingsQuery";
import { usePortalConfig } from "@/portal/usePortalConfig";

/** «Общие» — сквозные настройки инсталляции: они не принадлежат ни одному
 *  разделу, поэтому и страница у них своя, а не «всё остальное». Сервис ЧЗ
 *  показывается по флагу `honest_sign` из `/api/config`: где маркировки нет,
 *  настраивать нечего. */
export function GeneralSettingsPage(): React.ReactElement {
  const { honest_sign: honestSign } = usePortalConfig();
  const { data, isLoading, error, refetch } = useSystemSettingsQuery();

  if (isLoading || error || !data) {
    return (
      <div className="mx-auto max-w-2xl space-y-6">
        <SettingsPageHeader
          title="Общие"
          subtitle="Сквозные настройки инсталляции: способ сканирования и технические ссылки 1С."
        />
        <LoadState
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
          className="flex flex-col items-center gap-3 p-4 text-center"
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <SettingsPageHeader
        title="Общие"
        subtitle="Сквозные настройки инсталляции: способ сканирования и технические ссылки 1С."
      />
      <ScanMethodCard current={data.scan_method} />
      <TechRefsCard data={data} />
      {honestSign && <HonestSignCard data={data} />}
    </div>
  );
}
